import React from "react";

const Login = () => {
  const handleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-[#F9F9F8]">
      <div className="flex flex-col justify-center px-8 sm:px-16 py-12">
        <div className="max-w-md w-full mx-auto">
          <img src="/tilesmate-logo.png" alt="TilesMate" className="w-[320px] max-w-full h-auto" />

          <h1 className="font-display text-4xl sm:text-5xl font-medium tracking-tight text-[#1A1A1A] mt-16 leading-[1.05]">
            Job Management<br />Suite
          </h1>
          <p className="text-base text-[#4A4A4A] leading-relaxed mt-5">
            Internal Use Only
          </p>

          <button
            data-testid="google-login-btn"
            onClick={handleLogin}
            className="mt-10 w-full flex items-center justify-center gap-3 bg-[#2C2C2C] text-white rounded-md px-6 py-4 text-sm font-semibold hover:bg-[#1A1A1A] hover:-translate-y-[1px] transition-all"
          >
            <svg width="18" height="18" viewBox="0 0 24 24"><path fill="#fff" d="M12.24 10.4v3.83h5.4c-.24 1.4-1.66 4.1-5.4 4.1-3.25 0-5.9-2.7-5.9-6.02s2.65-6.02 5.9-6.02c1.85 0 3.1.79 3.8 1.47l2.6-2.5C17.06 3.2 14.86 2.2 12.24 2.2 6.98 2.2 2.7 6.48 2.7 11.74s4.28 9.54 9.54 9.54c5.5 0 9.15-3.87 9.15-9.32 0-.63-.07-1.1-.15-1.57h-9z"/></svg>
            Continue with Google
          </button>
          <p className="text-xs text-[#737373] mt-6">
            Access is invite-only. Only authorized team members and/or contractors can sign in.
          </p>
        </div>
      </div>
      <div className="hidden lg:block relative">
        <img
          src="https://customer-assets-lxgj4vgw.emergentagent.net/job_job-dispatch-hub-11/artifacts/6edkol0z_WhatsApp%20Image%202026-07-28%20at%2010.06.33%20AM.jpeg"
          alt="TilesMate showroom"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" />
      </div>
    </div>
  );
};

export default Login;
